'use client'

import { useTranslations } from 'next-intl'
import React from 'react'

import { useMobileNavigation } from '@maestro/commerce-blocks/providers/mobile-navigation/context'
import { Button } from '@pearlconvert/ui/components/button'

export default function NavigationMobileHeader() {
  const { closeMenu, activeNodeIds, closeLevel } = useMobileNavigation()
  const t = useTranslations('commerce-blocks')

  return (
    <div className="nav-mobile__header">
      {activeNodeIds.length === 1 ? (
        <span aria-hidden="true" className="nav-mobile__title">
          {t('navigation-header.menu')}
        </span>
      ) : (
        <button
          className="nav-mobile__back"
          onClick={closeLevel}
          title={t('navigation-header.previous-level')}
        >
          {t('navigation-header.back')}
        </button>
      )}
      <Button
        className="nav-mobile__close"
        onClick={closeMenu}
        title={t('navigation-header.close-menu')}
        type="empty"
        iconLeft="close"
        size="fixed"
      />
    </div>
  )
}
